export const SPOTS = [
  {
    id: "feliz-mango",
    rank: 1,
    name: "Feliz Mango Taqueria",
    aka: "Mango Feliz Taqueria",
    score: 9.6,
    approved: true,
    tags: ["truck", "late-night", "perfect-10"],
    type: "Food Truck",
    hood: "Southeast — The Concourse Project",
    address: "8509 Burleson Rd, Austin, TX 78719",
    hours: "Weeknights for Tesla/SpaceX crews · weekends at Concourse Project from 9 PM",
    price: "$3.50–$7 / taco",
    lat: 30.2076,
    lng: -97.6966,
    scores: { pastor: 9.6, asada: 9.6, chicken: 9.6, salsa: 9.7, tortilla: null },
    specialty: { name: "Birria", score: 10 },
    online: "4.2 Google · 4.7 Yelp — only 29 reviews",
    blurb:
      "The best taco in Austin is a truck with almost no online footprint, serving Tesla and SpaceX employees during the week and the Concourse Project crowd on weekends. Pastor, asada, and chicken all score 9.6 — the birria, soaked five to six hours, scores a perfect 10. The salsa, at 9.7, is the highest on the entire index. Built on product quality with minimal marketing. A staggering authenticity gap.",
    quirk: "The birria meat is soaked for five to six hours before it ever touches the plancha.",
    mapsQuery: "Mango Feliz Taqueria, 8509 Burleson Rd, Austin, TX",
  },
  {
    id: "la-casita",
    rank: 2,
    name: "La Casita del Pastor",
    aka: "Taqueria La Casita del Pastor",
    score: 9.3,
    approved: true,
    tags: ["truck", "late-night", "perfect-10"],
    type: "Food Truck",
    hood: "South Congress — outside a pawn shop",
    address: "4720 S Congress Ave, Austin, TX 78745",
    hours: "Open until 1 AM on weekends",
    price: "3 tacos for $10",
    lat: 30.2137,
    lng: -97.7456,
    scores: { pastor: 10, asada: null, chicken: 9, salsa: 8.8, tortilla: 8.8 },
    specialty: { name: "Al Pastor", score: 10 },
    online: "4.9 Google — one of the highest rated in South Austin",
    blurb:
      "Parked outside a pawn shop on South Congress, this truck serves the best single taco on the index: an al pastor scoring a perfect 10. Chicken lands at 9, tortilla and salsa both at 8.8, and the horchata is a bonus. Online and personal scores are fully aligned — this is what authentic recognition looks like.",
    quirk: "The orange salsa is fruity, spicy, and unlike anything else on the list.",
    mapsQuery: "Taqueria La Casita del Pastor, 4720 S Congress Ave, Austin, TX",
  },
  {
    id: "nixta",
    rank: 3,
    name: "Nixta Taqueria",
    aka: "Nixta Taqueria",
    score: 9.2,
    approved: true,
    tags: ["michelin"],
    type: "Restaurant",
    hood: "East 12th St",
    address: "2512 E 12th St, Austin, TX 78702",
    hours: "Counter service · dinner from 5 PM",
    price: "$3.50–$7 / taco",
    lat: 30.2737,
    lng: -97.7126,
    scores: { pastor: 9.2, asada: 9.2, chicken: 9.2, salsa: 9.2, tortilla: 9.2 },
    specialty: { name: "Duck Carnitas", score: 9.2 },
    online: "4.4 Google · Michelin Bib Gourmand · James Beard Award",
    blurb:
      "Chef Edgar Rico nixtamalizes heirloom corn and grinds it fresh daily, producing the most technically impressive tortilla in the city. The duck carnitas taco is a one-of-one. Everything scores 9.2 — and every bit of the acclaim comes from a decade of craft, not marketing.",
    quirk: "The tortilla is the hero — heirloom corn flavor that store-bought can't replicate.",
    mapsQuery: "Nixta Taqueria, 2512 E 12th St, Austin, TX",
  },
  {
    id: "las-amazonas",
    rank: 4,
    name: "Tacos Las Amazonas #1",
    aka: "Tacos las Amazonas Estilo Jalisco #1",
    score: 9.1,
    approved: true,
    tags: ["truck", "late-night"],
    type: "Food Truck",
    hood: "South Congress bar corridor",
    address: "3504 S Congress Ave, Austin, TX 78745",
    hours: "Open late — until 3 AM on weekends",
    price: "Small tacos + cold drinks, built for bar traffic",
    lat: 30.2287532,
    lng: -97.7612786,
    scores: { pastor: 9.2, asada: 9, chicken: null, salsa: 9.1, tortilla: 9 },
    specialty: { name: "Menudo", score: 9.7 },
    online: "4.8 Google · growing local following",
    blurb:
      "Jalisco-style technique: a spinning trompo, smoky grilled meats, vibrant salsas. Pastor at 9.2, steak at 9, menudo at 9.7. Positioned next to multiple bars on South Congress, the strategy of small tacos and cold drinks for late-night patrons is ruthlessly effective.",
    quirk: "Late-night foot traffic from the bar corridor drives the entire volume model.",
    mapsQuery: "Tacos las amazonas estilo Jalisco #1, 3504 S Congress Ave, Austin, TX",
  },
  {
    id: "taquito-aviles",
    rank: 5,
    name: "Taquito Aviles",
    aka: "Taquito Aviles",
    score: 9.1,
    approved: true,
    tags: ["perfect-10"],
    type: "Taqueria",
    hood: "North Austin — N Lamar",
    address: "11218 N Lamar Blvd, Austin, TX 78753",
    hours: "7 AM – 10 PM daily",
    price: "Menudo at an accessible price point",
    lat: 30.3794,
    lng: -97.6977,
    scores: { pastor: null, asada: null, chicken: null, salsa: 8.3, tortilla: 8.9 },
    specialty: { name: "Menudo", score: 10 },
    online: "Known locally for the best menudo in Austin",
    blurb:
      "Masters of the slow-cooked cut. Birria scores 9.7 and the menudo is a perfect 10 — the best in Austin, full stop. Corn tortilla at 8.9. The salsa, at 8.3, is spicy but one-dimensional; it hardly matters.",
    quirk: "The menudo alone justifies the drive to North Lamar.",
    mapsQuery: "Taquito Aviles, 11218 N Lamar Blvd, Austin, TX",
  },
  {
    id: "cuantos",
    rank: 6,
    name: "Cuantos Tacos",
    aka: "Cuantos Tacos",
    score: 9.07,
    approved: true,
    tags: ["michelin", "truck"],
    type: "Food Truck — Arbor Food Park",
    hood: "East 12th St",
    address: "1108 E 12th St, Austin, TX 78702",
    hours: "Lunch through evening · closed Mondays",
    price: "$3.50–$7 / taco",
    lat: 30.2736,
    lng: -97.726,
    scores: { pastor: 9, asada: null, chicken: null, salsa: null, tortilla: 7 },
    specialty: { name: "Cachete", score: 9.2 },
    online: "4.7 Google · Michelin Bib Gourmand",
    blurb:
      "Mexico City street tacos on 100% nixtamal tortillas pressed fresh daily. Suadero at 9, cachete at 9.2, pastor at 9 — the meat has a gravy-like consistency that defines the style. Notably, the tortilla at 7 is the weakest element: a Michelin-recognized spot where the tortilla is the weakest link.",
    quirk: "A Michelin-recognized spot where the tortilla is the weakest link.",
    mapsQuery: "Cuantos Tacos, 1108 E 12th St, Austin, TX",
  },
  {
    id: "de-diez",
    rank: 7,
    name: "Taqueria De Diez",
    aka: "Taqueria De Diez (D/10)",
    score: 8.8,
    approved: true,
    tags: ["late-night", "perfect-10"],
    type: "Speakeasy Taqueria",
    hood: "Downtown — behind a bar",
    address: "206 Trinity St Unit 110, Austin, TX 78701",
    hours: "11:30 AM – late · until 1 AM Thu–Sat",
    price: "$3.50–$7 / taco",
    lat: 30.2639708,
    lng: -97.7408126,
    scores: { pastor: 8.6, asada: 8.5, chicken: 9.3, salsa: 10, tortilla: null },
    specialty: { name: "Salsa", score: 10 },
    online: "4.8 Google · Texas Monthly feature",
    blurb:
      "Tijuana-style tacos in a speakeasy setting behind a downtown bar. Chicken at 9.3 leads the proteins. But the story is the salsa: a perfect 10 and the primary driver of return visits — the multiplier hypothesis, proven in a single condiment.",
    quirk: "The salsa drove a return visit entirely on its own.",
    mapsQuery: "Taqueria De Diez, 206 Trinity St, Austin, TX",
  },
  {
    id: "oye-taquito",
    rank: 8,
    name: "Oye Taquito 956",
    aka: "Oye Taquito 956",
    score: 8.67,
    approved: true,
    tags: [],
    type: "Taqueria",
    hood: "East Cesar Chavez",
    address: "1710 E Cesar Chavez St, Austin, TX 78702",
    hours: "11 AM – midnight",
    price: "Six mini tacos as a combo",
    lat: 30.2581,
    lng: -97.7266,
    scores: { pastor: null, asada: 9, chicken: null, salsa: 9, tortilla: 8 },
    specialty: { name: "Bistec, Matamoros-style", score: 9 },
    online: "4.5 Google · 4.7 DoorDash · strong East Austin following",
    blurb:
      "Matamoros-style tacos on small, thin corn tortillas — the most geographically specific style on the index. Bistec at 9, salsa at 9 (second only to Feliz Mango). The tortilla is basic at 8, but avocado and queso fresco elevate the whole bite. A true hidden gem.",
    quirk: "Named for the 956 — the Rio Grande Valley area code the style comes from.",
    mapsQuery: "Oye Taquito 956, 1710 E Cesar Chavez St, Austin, TX",
  },
  {
    id: "burrito-factory",
    rank: 9,
    name: "Burrito Factory",
    aka: "Burrito Factory",
    score: 8.63,
    approved: true,
    tags: ["campus"],
    type: "Counter — Dobie Mall",
    hood: "The Drag — UT Campus",
    address: "2025 Guadalupe St #244, Austin, TX 78705",
    hours: "Campus hours · closed Sundays",
    price: "Student-friendly",
    lat: 30.2835,
    lng: -97.742,
    scores: { pastor: 8.9, asada: 8.6, chicken: 8.3, salsa: 9.2, tortilla: null },
    specialty: { name: "Housemade Salsa", score: 9.2 },
    online: "4.7 Google — severely underrepresented online",
    blurb:
      "Severely underrated and underrepresented online; it thrives purely on word-of-mouth. Tacos range from 8.3 to 8.9, and the dangerously spicy housemade salsa at 9.2 is a top-tier element on the entire index.",
    quirk: "The salsa is not for the faint-hearted — and it is not optional.",
    mapsQuery: "Burrito Factory, 2025 Guadalupe St, Austin, TX",
  },
  {
    id: "juan-in-a-million",
    rank: 10,
    name: "Juan in a Million",
    aka: "Juan in a Million",
    score: 8.6,
    approved: true,
    tags: [],
    type: "Restaurant",
    hood: "East Cesar Chavez",
    address: "2300 E Cesar Chavez St, Austin, TX 78702",
    hours: "7 AM – 3 PM",
    price: "The Don Juan: enormous, priced like breakfast",
    lat: 30.2553537,
    lng: -97.7190658,
    scores: { pastor: 8.6, asada: 8.6, chicken: 8.6, salsa: 8.6, tortilla: 8.6 },
    specialty: { name: "The Don Juan", score: 8.6 },
    online: "4.5 Google · East Austin institution, nationally recognized",
    blurb:
      "An East Austin institution for decades. The Don Juan — potato, egg, cheese, bacon, enormous — is the order. Everything scores 8.6 across the board, including tortilla and salsa. Not the highest ceiling on the list, but flawless consistency, visit after visit.",
    quirk: "Perfect consistency across every single variable.",
    mapsQuery: "Juan in a Million, 2300 E Cesar Chavez St, Austin, TX",
  },
  {
    id: "la-catrina",
    rank: 11,
    name: "Tacos La Catrina",
    aka: "Tacos La Catrina",
    score: 8.43,
    approved: true,
    tags: ["truck"],
    type: "Food Truck",
    hood: "East Riverside",
    address: "1620 E Riverside Dr, Austin, TX 78741",
    hours: "Lunch through late evening",
    price: "$3.50–$7 / taco",
    lat: 30.2397,
    lng: -97.7253,
    scores: { pastor: 8.6, asada: 8.5, chicken: 8.2, salsa: 8, tortilla: 8 },
    specialty: null,
    online: "4.7 Google · growing",
    blurb:
      "Excels at marinated and grilled meats — pastor at 8.6 and asada at 8.5 are the strengths; chicken lags at 8.2. Tortilla and salsa both solid at 8. Worth the visit for the pastor and asada alone.",
    quirk: "Order the red meats. The chicken can wait.",
    mapsQuery: "Tacos La Catrina, 1620 E Riverside Dr, Austin, TX",
  },
  {
    id: "tacowey",
    rank: 12,
    name: "Tacowey",
    aka: "TacoWey",
    score: 8.3,
    approved: true,
    tags: ["campus", "late-night", "truck"],
    type: "Food Truck",
    hood: "UT Campus · late-night on E 6th",
    address: "UT campus rotation (day) · 325 E 6th St, Austin, TX 78701 (8 PM–2:30 AM)",
    hours: "Campus 11 AM–5 PM · late night 8 PM–2:30 AM",
    price: "Student-friendly price point",
    lat: 30.2664,
    lng: -97.7398,
    scores: { pastor: 8.3, asada: 8.3, chicken: 8.3, salsa: 8.3, tortilla: 8.3 },
    specialty: { name: "Flour Tortilla Tacos", score: 8.3 },
    online: "4.7 Google · student-driven following",
    blurb:
      "The campus workhorse. Flour tortillas are the defining feature, and everything scores a consistent 8.3. Reliable, accessible, good quality at a student-friendly price — campus positioning drives volume through pure foot traffic.",
    quirk: "Accessibility and affordability are the strategic advantage here.",
    mapsQuery: "TacoWey, 325 E 6th St, Austin, TX",
  },
  {
    id: "discada",
    rank: 13,
    name: "Discada",
    aka: "Discada",
    score: 8.2,
    approved: true,
    tags: ["truck"],
    type: "Food Truck — outside Chalmers",
    hood: "East Cesar Chavez",
    address: "1700 E Cesar Chavez St, Austin, TX 78702",
    hours: "Evenings from 4 PM · Sun 12–4 PM",
    price: "3, 5, or 8 tacos — that's the whole menu",
    lat: 30.2582,
    lng: -97.7268,
    scores: { pastor: null, asada: null, chicken: null, salsa: null, tortilla: null },
    specialty: { name: "Discada (cowboy-wok pork & beef)", score: 8.2 },
    online: "4.7 Google · Michelin Guide listed",
    blurb:
      "One taco, done with total commitment: a Northern Mexican cowboy-wok fusion of pork and beef cooked in a discada pan. Unique concept, excellent meat. The execution issue is structural — the tortilla cannot hold the volume of filling, and the scoring reflects it.",
    quirk: "The only spot on the index with a single taco.",
    mapsQuery: "Discada, 1700 E Cesar Chavez St, Austin, TX",
  },
  {
    id: "don-vegas",
    rank: 14,
    name: "Don Las Vegas Tacos",
    aka: "Don Vegas Tacos ATX",
    score: 8.07,
    approved: true,
    tags: ["campus", "perfect-10"],
    type: "Taqueria",
    hood: "The Drag — near UT",
    address: "1914 Guadalupe St, Austin, TX 78705",
    hours: "From 11 AM · closed Sundays",
    price: "Student following, student prices",
    lat: 30.2817,
    lng: -97.7421,
    scores: { pastor: 7.5, asada: 8.2, chicken: 8.5, salsa: 8, tortilla: 10 },
    specialty: { name: "Tortilla", score: 10 },
    online: "4.8 Google · near-campus following",
    blurb:
      "The tortilla is a perfect 10 — and consistently so, the best tortilla consistency on the entire index. Pastor at 7.5 is the weakest individual score on the approved list (slightly greasy), but asada at 8.2 and chicken at 8.5 on that tortilla foundation prove the value of consistency.",
    quirk: "Best tortilla consistency on the entire list.",
    mapsQuery: "Don Vegas tacos atx, 1914 Guadalupe St, Austin, TX",
  },
  {
    id: "tysons",
    rank: 15,
    name: "Tyson's Tacos",
    aka: "Tyson's Tacos",
    score: 8.0,
    approved: true,
    tags: ["late-night"],
    type: "Taco Stand",
    hood: "Airport Blvd",
    address: "4905 Airport Blvd, Austin, TX 78751",
    hours: "Open 24 hours",
    price: "$3.50–$7 / taco",
    lat: 30.3084,
    lng: -97.7155,
    scores: { pastor: 8, asada: 8, chicken: 8, salsa: 8.4, tortilla: 7.5 },
    specialty: null,
    online: "4.3 Google · food truck following",
    blurb:
      "Solid across the board without excelling in any single category. The salsa at 8.4 is the strongest element; the tortilla at 7.5 is the weakest. A reliable spot — and it's open 24 hours, which forgives a lot.",
    quirk: "Open 24 hours. Reliability is the product.",
    mapsQuery: "Tyson's Tacos, 4905 Airport Blvd, Austin, TX",
  },
  {
    id: "veracruz",
    rank: 16,
    name: "Veracruz All Natural",
    aka: "Veracruz All Natural",
    score: 7.8,
    approved: false,
    verdict: "NOT APPROVED — TOP TIER",
    tags: [],
    type: "Food Trailer — multiple locations",
    hood: "Webberville Rd (original) + citywide",
    address: "2505 Webberville Rd, Austin, TX 78702",
    hours: "Breakfast & lunch · closes 9 PM",
    price: "$3.50–$7 / taco",
    lat: 30.2629831,
    lng: -97.7138705,
    scores: { pastor: 8, asada: 7.5, chicken: 7.9, salsa: 7.5, tortilla: 7 },
    specialty: null,
    online: "4.6 Google · Rachael Ray endorsed · national press",
    blurb:
      "The lowest score among visited spots and the highest online recognition — 7.8 in person against a 9+ online perception, the largest authenticity gap in the study. Pastor at 8, steak at 7.5, chicken at 7.9, tortilla at 7, salsa at 7.5. Not bad scores — but against the hype, this is a good taco spot marketed as a great one.",
    quirk: "The default tourist recommendation. The data disagrees.",
    mapsQuery: "Veracruz All Natural, 2505 Webberville Rd, Austin, TX",
  },
  {
    id: "taco-haus",
    rank: 17,
    name: "Taco Haus",
    aka: "Taco Haus",
    score: 6.47,
    approved: false,
    verdict: "NOT APPROVED",
    tags: ["late-night"],
    type: "Restaurant — Westin food court",
    hood: "Downtown — E 5th St",
    address: "318 E 5th St, Austin, TX 78701",
    hours: "9 AM – 3 AM daily",
    price: "High-traffic tourist pricing",
    lat: 30.2665,
    lng: -97.7405,
    scores: { pastor: 7.1, asada: 6.4, chicken: 6, salsa: 5, tortilla: 6 },
    specialty: null,
    online: "4.7 Google — nearly a 3-point gap vs. in-person score",
    blurb:
      "The overrated trap, documented: 4.7 stars online, 6.47 in person. Salsa at 5 is generic and lacks soul; tortillas at 6 are store-bought generic. Nothing is terrible, everything is mediocre — yet the algorithm says it's among the best. Location convenience plus high-volume casual traffic plus algorithmic amplification equals ratings unrelated to quality.",
    quirk: "Ratings based on hunger satisfaction, not quality. A systemic problem.",
    mapsQuery: "Taco Haus, 318 E 5th St, Austin, TX",
  },
];

export const mapsUrl = (spot) =>
  `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(spot.mapsQuery)}`;

export const LATE_NIGHT = [
  { name: "Tacos Las Amazonas #1", detail: "South Congress bar corridor — open until 3 AM on weekends" },
  { name: "Feliz Mango Taqueria", detail: "The Concourse Project on weekends — a late-night venue" },
  { name: "La Casita del Pastor", detail: "South Congress — open until 1 AM on weekends" },
  { name: "Taqueria De Diez", detail: "Literally behind a downtown bar — until 1 AM Thu–Sat" },
];

export const PHOTOS = Object.fromEntries(SPOTS.map((s) => [s.id, `/photos/${s.id}.jpg`]));
